import React from 'react';
import { Box, Typography, Dialog, IconButton } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { makeStyles } from '@mui/styles';
import './confirm.scss';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: '1rem',
  },
}));

interface InfoKnowledgeDialogProps {
  openInfoKnowledgeDialog: boolean;
  closeDialog: () => void;
  label: string;
}

const InfoKnowledgeDialog: React.FC<InfoKnowledgeDialogProps> = (props) => {
  const { openInfoKnowledgeDialog, closeDialog, label } = props;
  const styles = useStyles();

  const handleClose = () => closeDialog();

  return (
    <Dialog
      onClose={handleClose}
      open={openInfoKnowledgeDialog}
      maxWidth='lg'
      classes={{ paper: styles.paper }}
    >
      <Box className='mainDialog'>
        <Box className='header'>
          <Typography color='text.main' fontWeight='bold'>
            {label}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseRoundedIcon color='action' />
          </IconButton>
        </Box>

        <Box mb={2} mt={1}>
          <Typography>
            این سامانه با استفاده از محاسبات دقیق علمی و بررسی ویژگی های شخصی ما و با بهره گیری از
            هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می دهد.
            و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و
            محتوی رشد فردی را در اختیار شما قرار می دهداین سامانه با استفاده از محاسبات دقیق علمی و
            بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و
            محتوی رشد فردی را در اختیار شما قرار می دهد. و بررسی ویژگی های شخصی ما و با بهره گیری از
            هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می
            دهداین سامانه با استفاده از محاسبات دقیق علمی و بررسی ویژگی های شخصی ما و با بهره گیری
            از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می
            دهد. و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین
            برنامه و محتوی رشد فردی را در اختیار شما قرار می دهداین سامانه با استفاده از محاسبات
            دقیق علمی و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین
            برنامه و محتوی رشد فردی را در اختیار شما قرار می دهد. و بررسی ویژگی های شخصی ما و با
            بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما
            قرار می دهداین سامانه با استفاده از محاسبات دقیق علمی و بررسی ویژگی های شخصی ما و با
            بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما
            قرار می دهد. و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع
            ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می دهداین سامانه با استفاده از
            محاسبات دقیق علمی و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و
            جامع ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می دهد. و بررسی ویژگی های شخصی
            ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در
            اختیار شما قرار می دهداین سامانه با استفاده از محاسبات دقیق علمی و بررسی ویژگی های شخصی
            ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در
            اختیار شما قرار می دهد. و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه
            ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می دهداین سامانه با
            استفاده از محاسبات دقیق علمی و بررسی ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی،
            بهینه ترین و جامع ترین برنامه و محتوی رشد فردی را در اختیار شما قرار می دهد. و بررسی
            ویژگی های شخصی ما و با بهره گیری از هوش مصنوعی، بهینه ترین و جامع ترین برنامه و محتوی
            رشد فردی را در اختیار شما قرار می دهداین سامانه با استفاده از محاسبات دقیق علمی و بررسی
            ویژگی های شخصی ما و با به
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default InfoKnowledgeDialog;
